/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourseDetail
 */
export interface CourseDetail {
    /**
     * 
     * @type {number}
     * @memberof CourseDetail
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CourseDetail
     */
    officeId: number;
    /**
     * 
     * @type {string}
     * @memberof CourseDetail
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CourseDetail
     */
    nameEn: string;
    /**
     * 
     * @type {string}
     * @memberof CourseDetail
     */
    shortName: string;
    /**
     * 
     * @type {string}
     * @memberof CourseDetail
     */
    descriptionType?: CourseDetailDescriptionTypeEnum;
    /**
     *
     * @type {boolean}
     * @memberof CourseDetail
     */
    showApplicationDestinationAlert: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseDetail
     */
    state: CourseDetailStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum CourseDetailDescriptionTypeEnum {
    Agriculture = 'Agriculture',
    Information = 'Information',
    Economics = 'Economics',
    Humanities = 'Humanities',
    Medicine = 'Medicine',
    Biomedical = 'Biomedical',
    Fisheries = 'Fisheries',
    Dental = 'Dental'
}/**
* @export
* @enum {string}
*/
export enum CourseDetailStateEnum {
    Active = 'active',
    Hidden = 'hidden'
}

export function CourseDetailFromJSON(json: any): CourseDetail {
    return CourseDetailFromJSONTyped(json, false);
}

export function CourseDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourseDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'officeId': json['officeId'],
        'name': json['name'],
        'nameEn': json['nameEn'],
        'shortName': json['shortName'],
        'descriptionType': !exists(json, 'descriptionType') ? undefined : json['descriptionType'],
        'showApplicationDestinationAlert': json['showApplicationDestinationAlert'],
        'state': json['state'],
    };
}

export function CourseDetailToJSON(value?: CourseDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'officeId': value.officeId,
        'name': value.name,
        'nameEn': value.nameEn,
        'shortName': value.shortName,
        'descriptionType': value.descriptionType,
        'showApplicationDestinationAlert': value.showApplicationDestinationAlert,
        'state': value.state,
    };
}

